import { render, staticRenderFns } from "./ShortCheckbox.vue?vue&type=template&id=27281cc7&"
import script from "./ShortCheckbox.vue?vue&type=script&lang=js&"
export * from "./ShortCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports